var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { Chart, registerables } from "chart.js";
Chart.register.apply(Chart, registerables);
var opinion = document.querySelector("#opinion");
var engagement = document.querySelector("#engagement");
var score = document.querySelector("#score");
var roomCode = document.querySelector("#roomCode");
var minMaxRow = document.querySelector("#minMaxRow");
var roomMax = document.querySelector("#roomMax");
var roomMin = document.querySelector("#roomMin");
var joinButton = document.querySelector("#join");
var voteGraph = document.querySelector("#voteGraph");
var chart;
var room;
var roomJoined = false;
var intervalId;
var roomData = { votes: 0, voteGraph: [], startTime: 0 };
var voteData = [];
var voteGraphPoints = [];
var engageGraphPoints = [];
function createRoom(roomCode) {
    var req = new XMLHttpRequest();
    req.open("POST", "/presentinator/api/create/", true);
    req.setRequestHeader("Content-Type", "application/json");
    req.onreadystatechange = function () {
        if (req.readyState == 4 && req.status == 200) {
            var resp = JSON.parse(req.response);
            if (resp.code == 0) {
                console.log("Room created successfully");
            }
            else {
                console.log("Room creation failed with code " + resp.code);
            }
        }
    };
    req.send(JSON.stringify({ room: roomCode, max: roomMax.value, min: roomMin.value }));
}
function updateChart() {
    voteGraphPoints = voteData.map(function (val) { return { x: val.time, y: val.votes }; });
    engageGraphPoints = new Array(Math.floor(voteData[voteData.length - 1].time) + 1);
    var totalOpinion = 0;
    for (var i = 0; i < engageGraphPoints.length - 1; i++) {
        engageGraphPoints[i] = { x: i, y: 0 };
    }
    engageGraphPoints[engageGraphPoints.length - 1] = { x: voteData[voteData.length - 1].time, y: 0 };
    for (var i = 0; i < voteData.length; i++) {
        engageGraphPoints[Math.floor(voteData[i].time)].y++;
        if (i != 0) {
            totalOpinion += (voteData[i].votes + voteData[i - 1].votes) / 2 * (voteData[i].time - voteData[i - 1].time);
        }
    }
    chart.data.datasets[0].data = __spreadArray([], voteGraphPoints, true);
    chart.data.datasets[1].data = __spreadArray([], engageGraphPoints, true);
    chart.update("none");
    var opinionScore = totalOpinion / voteData[voteData.length - 1].time;
    var engagementScore = voteData.length / voteData[voteData.length - 1].time;
    opinion.textContent = "Opinion Score: " + Math.floor(opinionScore * 100) / 100;
    engagement.textContent = "Engagement Score: " + Math.floor(engagementScore * 100) / 100;
    score.textContent = "Score: " + Math.floor((opinionScore + engagementScore) * 100) / 100;
}
function loop() {
    var req = new XMLHttpRequest();
    req.open("POST", "/presentinator/api/hostinfo/", true);
    req.setRequestHeader("Content-Type", "application/json");
    req.onreadystatechange = function () {
        if (req.readyState == 4 && req.status == 200) {
            roomData = JSON.parse(req.response).room;
            voteData = roomData.voteGraph;
            updateChart();
        }
    };
    req.send(JSON.stringify({ room: room }));
}
function setup() {
    var urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has("room")) {
        roomCode.value = urlParams.get("room");
    }
    chart = new Chart(voteGraph, {
        type: 'line',
        data: {
            datasets: [{
                    label: 'Opinion',
                    data: voteGraphPoints,
                    fill: true,
                    pointRadius: 0
                }, {
                    label: "Engagement",
                    data: [],
                    fill: true,
                    pointRadius: 0
                }]
        },
        options: {
            indexAxis: "x",
            scales: {
                x: {
                    type: "linear",
                    beginAtZero: true,
                    title: {
                        text: "Time",
                        display: true
                    },
                    bounds: "data"
                },
                y: {
                    type: "linear",
                    beginAtZero: true,
                    title: {
                        text: "Votes",
                        display: true
                    }
                }
            }
        }
    });
    roomCode.oninput = function () {
        var req = new XMLHttpRequest();
        req.open("POST", "/presentinator/api/hostinfo/", true);
        req.setRequestHeader("Content-Type", "application/json");
        req.onreadystatechange = function () {
            if (req.readyState == 4 && req.status == 200) {
                var resp = JSON.parse(req.response);
                if (resp.code == 0) {
                    joinButton.textContent = "Join";
                }
                else {
                    joinButton.textContent = "Create";
                }
            }
        };
        req.send(JSON.stringify({ room: roomCode.value }));
    };
    joinButton.onclick = function () {
        if (roomJoined) {
            clearInterval(intervalId);
            voteData.push({ time: (Date.now() - roomData.startTime) / 1000, votes: voteData[voteData.length - 1].votes });
            updateChart();
        }
        else {
            room = roomCode.value;
            var req_1 = new XMLHttpRequest();
            req_1.open("POST", "/presentinator/api/hostinfo/", true);
            req_1.setRequestHeader("Content-Type", "application/json");
            req_1.onreadystatechange = function () {
                if (req_1.readyState == 4 && req_1.status == 200) {
                    var resp = JSON.parse(req_1.response);
                    if (resp.code == 0) {
                        //room variable already set
                    }
                    else {
                        createRoom(room);
                    }
                    intervalId = setInterval(loop, 100);
                    minMaxRow.style.display = "none";
                    joinButton.textContent = "End Room";
                    roomCode.disabled = true;
                    roomJoined = true;
                    window.history.pushState({ id: "100" }, "Room: ".concat(room), "/presentinator/host/?room=".concat(room.toLowerCase()));
                }
            };
            req_1.send(JSON.stringify({ room: room }));
        }
    };
}
setup();
